export default __webpack_public_path__ + "static/media/insta.6c303b5c.png";